<div id="level-two" style="margin-left: 1px;">
  <div class="blockContainer" id='finance'>
    <div class="breadcrumbWrapper" *ngIf="!hideBreadcrumb">
      <app-breadcrumb></app-breadcrumb>
    </div>
    <div class="combination-loader">
      <!-- Showing cart names -->
      <div class="child-sidebar">
        <child-header [title]="title" (closeEvent)="close()"></child-header>
        <!-- <div class="page-title-wrapper">
          <div class="title blade-title-font">
            {{title}}
          </div>
          <i class="material-icons closebutton-pullfloat-right" (click)="close()">close</i>
        </div> -->
        <loading-screen *ngIf="!loadContent" [isScrolled]="true" [showBlurTable]="false" backDropWidth="280"
          (currentLoadingStatus)="onLoading($event)"></loading-screen>
        <div class="child-body">
          <div class="financeRadio">
            <label>FINANCE FOR</label>
            <mat-radio-group class="example-radio-group" [(ngModel)]="financeFor" (ngModelChange)="showFinanceDetails()">
              <mat-radio-button class="example-radio-button" value="me">
                Me
              </mat-radio-button>
              <mat-radio-button class="example-radio-button" value="enduser">
                End User
              </mat-radio-button>
            </mat-radio-group>
          </div>
        </div>  
      </div>
     
      <div class="child-loader">
        <router-outlet></router-outlet>
      </div>
    </div>
  </div>
</div>